import type { InMemoryCacheConfig } from '@apollo/client';

import fragmentTypes from 'src/api/__generated__/fragmentTypes';

export const createApolloCacheConfig = (): InMemoryCacheConfig => ({
  possibleTypes: fragmentTypes.possibleTypes,
  typePolicies: {
    Query: {
      fields: {
        // add more lists if needed
      },
    },
  },
});
